var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"BannerContent"},[_c('div',{staticClass:"CopyContainer",class:{
      'Light': _vm.theme === 'light',
      'Dark': _vm.theme === 'dark'
    }},[_c('base-header',[_vm._t("title",function(){return [_c('span',{domProps:{"innerHTML":_vm._s(_vm.title)}})]},{"slot":"title"}),_vm._t("byline",function(){return [_c('span',{domProps:{"innerHTML":_vm._s(_vm.byline)}})]},{"slot":"byline"})],2)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }